(() => {
  const prepareLink = (link) => {
    let url;
    try {
      url = new URL(link.getAttribute('href'), document.baseURI);
    } catch {
      return;
    }
    if (!['http:', 'https:'].includes(url.protocol) || !/\.pdf$/i.test(url.pathname)) return;
    link.target = '_blank';
    link.relList.add('noopener');
  };

  const prepareLinks = (root) => {
    if (root.matches?.('a[href]')) prepareLink(root);
    root.querySelectorAll?.('a[href]').forEach(prepareLink);
  };

  prepareLinks(document);
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') prepareLinks(mutation.target);
      else mutation.addedNodes.forEach(prepareLinks);
    }
  }).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
})();
